import { render, staticRenderFns } from "./clientGroupList.vue?vue&type=template&id=654ea5ea&scoped=true"
import script from "./clientGroupList.vue?vue&type=script&lang=js"
export * from "./clientGroupList.vue?vue&type=script&lang=js"
import style0 from "./clientGroupList.vue?vue&type=style&index=0&id=654ea5ea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654ea5ea",
  null
  
)

export default component.exports